import { stationTransformer } from "@/helpers"
import { getAccountStations, getAccountDeletedStations } from "@/services/AccountService"

export const fetchAccountStations = async (vuex, accountKey) => {
  const stations = await getAccountStations(accountKey)

  vuex.commit("setAccountStations", stations.map(stationTransformer()))

  return stations
}

export const resetAccountStations = async ({ commit }) => {
  commit("resetStations")
}

// deleted stations
export const fetchAccountDeletedStations = async (vuex, accountKey) => {
  const stations = await getAccountDeletedStations(accountKey)

  vuex.commit("setAccountDeletedStations", stations.map(stationTransformer()))
}

